import { Injectable } from '@angular/core';
import { AppNotificationUtilClass, Plani8DataService } from '@monorepo/services';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { switchMap, map, catchError, finalize, take } from 'rxjs/operators';
import { TTnaBoardActionType } from './tna-board.models';
import { GetTnaTemplateList } from '../tna-templates/tna-templates.actions';
import { GetTnaBoardListFailure, GetTnaBoardListSuccess } from './tna-board.actions';

@Injectable({ providedIn: 'root' })
export class TnaBoardEffects {
  constructor(
    private actions$: Actions,
    private plani8DataService: Plani8DataService,
    private appNotificationUtilClass: AppNotificationUtilClass,
  ) {}

  getTnaBoardList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TTnaBoardActionType.GetTnaBoardList),
      switchMap((action: GetTnaTemplateList) =>
        from(this.appNotificationUtilClass.presentLoading()).pipe(
          take(1),
          map((loaderEl) => {
            return [loaderEl, action] as const;
          }),
        ),
      ),
      switchMap(([loaderEl, action]) =>
        this.plani8DataService.getTnaBoardListing(action.payload).pipe(
          finalize(() => {
            this.appNotificationUtilClass.dismissLoadingV2(loaderEl);
          }),
          map((res) => new GetTnaBoardListSuccess(res)),
          catchError(() => {
            return of(new GetTnaBoardListFailure());
          }),
        ),
      ),
    ),
  );
}
